import { Link } from 'react-router-dom';

interface ArticleCard {
  id: string;
  title: string;
  excerpt: string;
  slug: string;
  imageUrl: string;
  readTime: string;
  category: string;
}

const articles: ArticleCard[] = [
  {
    id: 'guide',
    title: 'The Ultimate Sugargoo Spreadsheet Guide 2026',
    excerpt: 'A comprehensive resource covering everything from getting started with Sugargoo Spreadsheet to mastering advanced shopping strategies, product discovery techniques, and shipping optimization.',
    slug: '/sugargoo-spreadsheet-guide',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20colorful%20spreadsheet%20data%20and%20charts%20on%20a%20clean%20white%20desk%2C%20warm%20natural%20lighting%2C%20coffee%20cup%20nearby%2C%20organized%20productivity%20aesthetic%2C%20soft%20shadows%2C%20professional%20yet%20inviting%20atmosphere&width=800&height=500&seq=seo-card-guide-01&orientation=landscape',
    readTime: '12 min read',
    category: 'Guide',
  },
  {
    id: 'shipping',
    title: 'Sugargoo Shipping Cost: Complete Price Breakdown 2026',
    excerpt: 'Understand exactly how Sugargoo shipping costs are calculated. Compare carriers, weight brackets, and destination pricing with our detailed analysis and money-saving consolidation tips.',
    slug: '/sugargoo-shipping-cost',
    imageUrl: 'https://readdy.ai/api/search-image?query=International%20shipping%20and%20logistics%20concept%20with%20cardboard%20boxes%20and%20a%20calculator%20on%20a%20clean%20wooden%20desk%2C%20world%20map%20in%20background%2C%20warm%20ambient%20lighting%2C%20professional%20ecommerce%20photography%2C%20organized%20shipping%20station%20aesthetic&width=800&height=500&seq=seo-card-shipping-02&orientation=landscape',
    readTime: '10 min read',
    category: 'Shipping',
  },
  {
    id: 'legit',
    title: 'Is Sugargoo Legit? Complete Safety Review Before Buying',
    excerpt: 'In-depth safety analysis covering Sugargoo buyer protection, payment security, warehouse quality control, and real user experiences. Everything you need to know before placing your first order.',
    slug: '/is-sugargoo-legit',
    imageUrl: 'https://readdy.ai/api/search-image?query=Security%20shield%20and%20checkmark%20concept%20on%20a%20clean%20minimalist%20desk%20with%20soft%20natural%20light%2C%20trust%20and%20verification%20symbolism%2C%20modern%20corporate%20photography%20style%2C%20warm%20beige%20and%20cream%20tones%2C%20professional%20atmosphere&width=800&height=500&seq=seo-card-legit-03&orientation=landscape',
    readTime: '8 min read',
    category: 'Safety',
  },
  {
    id: 'coupon',
    title: 'Sugargoo Coupon & Discount Code: Latest Saving Methods 2026',
    excerpt: 'Discover all the latest ways to save on Sugargoo including promotional coupons, seasonal discounts, referral programs, and shipping promotions that can cut your total costs significantly.',
    slug: '/sugargoo-coupon',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shopping%20discount%20concept%20with%20colorful%20price%20tags%20and%20a%20calculator%20on%20a%20soft%20pastel%20colored%20desk%2C%20warm%20ambient%20light%2C%20savings%20and%20bargain%20shopping%20theme%2C%20clean%20minimalist%20product%20photography%2C%20cheerful%20aesthetic&width=800&height=500&seq=seo-card-coupon-04&orientation=landscape',
    readTime: '7 min read',
    category: 'Savings',
  },
  {
    id: 'warehouse',
    title: 'Sugargoo Warehouse Explained: Storage, QC Photos & Consolidation',
    excerpt: 'Complete walkthrough of how the Sugargoo warehouse works. Learn about free storage periods, quality check photography, item consolidation strategies, and warehouse management best practices.',
    slug: '/sugargoo-warehouse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20warehouse%20interior%20with%20organized%20shelves%20and%20cardboard%20boxes%20in%20warm%20lighting%2C%20clean%20minimalist%20logistics%20center%20aesthetic%2C%20professional%20product%20photography%2C%20soft%20industrial%20design%2C%20orderly%20storage%20environment&width=800&height=500&seq=seo-card-warehouse-05&orientation=landscape',
    readTime: '9 min read',
    category: 'Guide',
  },
  {
    id: 'vs-competitors',
    title: 'Sugargoo vs Competitors: Pandabuy, Superbuy & CSSBuy Compared',
    excerpt: 'Honest side-by-side comparison of Sugargoo against major shopping agents. Compare pricing, shipping speed, warehouse services, user experience, and spreadsheet community resources.',
    slug: '/sugargoo-vs-competitors',
    imageUrl: 'https://readdy.ai/api/search-image?query=Comparison%20concept%20with%20two%20columns%20of%20product%20boxes%20on%20a%20clean%20minimalist%20surface%2C%20versus%20symbolism%2C%20warm%20natural%20lighting%2C%20professional%20ecommerce%20comparison%20photography%2C%20clean%20and%20balanced%20composition&width=800&height=500&seq=seo-card-vs-06&orientation=landscape',
    readTime: '11 min read',
    category: 'Comparison',
  },
  {
    id: 'best-finds',
    title: 'Best Sugargoo Spreadsheet Finds 2026: Trending Products & Hidden Gems',
    excerpt: 'Curated collection of the most popular and highly-rated product discoveries from the Sugargoo Spreadsheet community. From streetwear essentials to unique accessories worth adding to your haul.',
    slug: '/sugargoo-best-finds',
    imageUrl: 'https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20and%20accessories%20beautifully%20arranged%20on%20a%20minimalist%20white%20surface%20with%20warm%20natural%20light%2C%20curated%20collection%20aesthetic%2C%20editorial%20product%20photography%2C%20clean%20and%20stylish%20composition&width=800&height=500&seq=seo-card-finds-07&orientation=landscape',
    readTime: '9 min read',
    category: 'Discoveries',
  },
  {
    id: 'beginner-tutorial',
    title: 'Sugargoo Beginner Tutorial: First Order Step-by-Step Walkthrough',
    excerpt: 'Brand new to Sugargoo? This beginner-friendly tutorial walks you through everything — from signing up and searching products to placing your first order, checking QC photos, and choosing shipping.',
    slug: '/sugargoo-beginner-tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20typing%20on%20a%20laptop%20with%20a%20notebook%20and%20coffee%20on%20a%20clean%20wooden%20desk%2C%20warm%20natural%20light%20from%20window%2C%20cozy%20learning%20atmosphere%2C%20modern%20minimalist%20workspace%2C%20soft%20and%20inviting%20aesthetic&width=800&height=500&seq=seo-card-beginner-08&orientation=landscape',
    readTime: '10 min read',
    category: 'Tutorial',
  },
  {
    id: 'save-money',
    title: 'How to Save Money with Sugargoo: 15 Proven Strategies',
    excerpt: 'Master the art of saving on every Sugargoo order. From consolidation tricks and shipping line selection to seasonal sale timing and spreadsheet-powered bargain hunting — maximize every dollar.',
    slug: '/sugargoo-save-money',
    imageUrl: 'https://readdy.ai/api/search-image?query=Piggy%20bank%20and%20coins%20with%20shopping%20bags%20on%20a%20warm%20wooden%20table%2C%20money%20saving%20concept%2C%20soft%20natural%20lighting%2C%20clean%20minimalist%20photography%2C%20warm%20cozy%20atmosphere%2C%20financial%20planning%20aesthetic&width=800&height=500&seq=seo-card-save-09&orientation=landscape',
    readTime: '8 min read',
    category: 'Savings',
  },
];

export default function SEOArticlesGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50" id="articles">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 border border-accent-200/60 mb-5">
            <i className="ri-article-line text-accent-600 text-sm"></i>
            <span className="text-xs font-medium text-accent-700">SEO Resource Hub</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Knowledge Base
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our collection of in-depth guides, tutorials, and resources covering everything you need to master international shopping with Sugargoo Spreadsheet intelligence
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group relative overflow-hidden rounded-2xl bg-background-100 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-800">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/60">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line text-xs"></i>
                    {article.readTime}
                  </span>
                  <span className="text-xs font-medium text-primary-500 flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                    Read Article
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer"
          >
            Visit Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}